import { useCallback, useEffect, useMemo, useState } from "react"

import { GridSortModel } from "@mui/x-data-grid"
import { useMatch } from "react-router-dom"

import { APP_CAMPAIGN, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"

import {
    CampaignDetailDispatchContext,
    CampaignDetailStateContext,
    CampaignDetailViewMode,
    initialState,
} from "./CampaignDetailContext.context"

interface CampaignDetailContextProviderProps {
    children: React.ReactNode
}

export function CampaignDetailContextProvider(props: CampaignDetailContextProviderProps) {
    const { children } = props

    const [state, setState] = useState(initialState)

    const matchCampaignDetail = useMatch(`:slugId/${APP_CAMPAIGN}/${MODULE_CAMPAIGNS}/:campaignId/*`)
    const campaignId = matchCampaignDetail?.params?.campaignId

    useEffect(() => {
        setState(initialState)
    }, [campaignId])

    const setViewMode = useCallback((viewMode: CampaignDetailViewMode) => {
        setState(prevState => ({ ...prevState, viewMode }))
    }, [])

    const setSort = useCallback((sortModel: GridSortModel, sortHistory: string[]) => {
        setState(prevState => ({ ...prevState, sortModel, sortHistory }))
    }, [])

    const stateValue = useMemo(() => {
        return state
    }, [state])

    const dispatchValue = useMemo(() => {
        return {
            setViewMode,
            setSort,
        }
    }, [setViewMode, setSort])

    return (
        <CampaignDetailStateContext.Provider value={stateValue}>
            <CampaignDetailDispatchContext.Provider value={dispatchValue}>
                {children}
            </CampaignDetailDispatchContext.Provider>
        </CampaignDetailStateContext.Provider>
    )
}
